import React from 'react';
import '../assets/styles/blog.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import { articlesData } from '../data/articlesData';

type ArticleTranslation = { title: string; excerpt: string };

function Blog() {
  const { t } = useTranslation();
  usePageTitle('Blog');
  const articles = t('articles', { returnObjects: true }) as ArticleTranslation[];

  return (
    <section className="blog-section">
      <div className="blog-header">
        <h1>{t('blogTitle')}</h1>
        <div className="blog-rule" />
        <p className="blog-description">{t('blogDesc')}</p>
      </div>
      <div className="blog-grid">
        {articlesData.map((article, index) => {
          const translated = Array.isArray(articles) ? articles[index] : null;
          const title = translated?.title ?? article.title;
          const excerpt = translated?.excerpt ?? article.excerpt;

          return (
            <div key={article.id} className="blog-card">
              <div className="blog-card-meta">
                <span className="blog-card-tag">{t('blogTag')}</span>
                <span className="blog-card-reading-time">
                  {article.readingTime} min
                </span>
              </div>
              <h3 className="blog-card-title">{title}</h3>
              <p className="blog-card-excerpt">{excerpt}</p>
              <Link to={`/blog/${article.slug}`} className="blog-card-link">
                {t('readMore')}
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Blog;
